/**
 * 基于 IANA 时区数据库 (tzdb-2025b) 的完整时区数据
 * 包含航空业常用的时区和机场时区
 *
 * 数据来源：https://www.iana.org/time-zones
 * 版本：2025b (Released 2025-03-22)
 */

// 航空业常用时区列表 - 基于 IANA zone1970.tab 和实际航空需求
export const AVIATION_TIMEZONES = {
    // UTC 基准时区
    UTC: "UTC",

    // 北美洲主要时区
    "America/New_York": "New York (Eastern)",
    "America/Chicago": "Chicago (Central)",
    "America/Denver": "Denver (Mountain)",
    "America/Los_Angeles": "Los Angeles (Pacific)",
    "America/Anchorage": "Anchorage (Alaska)",
    "America/Toronto": "Toronto",
    "America/Vancouver": "Vancouver",
    "America/Montreal": "Montreal",
    "America/Halifax": "Halifax",
    "America/St_Johns": "St. John's",
    "America/Mexico_City": "Mexico City",
    "America/Tijuana": "Tijuana",
    "America/Cancun": "Cancun",

    // 南美洲主要时区
    "America/Sao_Paulo": "São Paulo",
    "America/Buenos_Aires": "Buenos Aires",
    "America/Santiago": "Santiago",
    "America/Lima": "Lima",
    "America/Bogota": "Bogotá",
    "America/Caracas": "Caracas",
    "America/La_Paz": "La Paz",
    "America/Montevideo": "Montevideo",
    "America/Asuncion": "Asunción",
    "America/Guayaquil": "Guayaquil",

    // 欧洲主要时区
    "Europe/London": "London",
    "Europe/Paris": "Paris",
    "Europe/Berlin": "Berlin", // 德国、丹麦、挪威、瑞典主要时区
    "Europe/Rome": "Rome",
    "Europe/Madrid": "Madrid",
    "Europe/Amsterdam": "Amsterdam",
    "Europe/Brussels": "Brussels",
    "Europe/Zurich": "Zurich",
    "Europe/Vienna": "Vienna",
    "Europe/Prague": "Prague",
    "Europe/Budapest": "Budapest",
    "Europe/Warsaw": "Warsaw",
    "Europe/Stockholm": "Stockholm",
    "Europe/Copenhagen": "Copenhagen",
    "Europe/Oslo": "Oslo",
    "Europe/Helsinki": "Helsinki",
    "Europe/Athens": "Athens",
    "Europe/Istanbul": "Istanbul",
    "Europe/Moscow": "Moscow",
    "Europe/Kiev": "Kiev",
    "Europe/Bucharest": "Bucharest",
    "Europe/Sofia": "Sofia",
    "Europe/Belgrade": "Belgrade",
    "Europe/Zagreb": "Zagreb",
    "Europe/Ljubljana": "Ljubljana",
    "Europe/Sarajevo": "Sarajevo",
    "Europe/Skopje": "Skopje",
    "Europe/Podgorica": "Podgorica",
    "Europe/Tirana": "Tirana",
    "Europe/Dublin": "Dublin",
    "Europe/Lisbon": "Lisbon",
    "Europe/Reykjavik": "Reykjavik",
    "Europe/Luxembourg": "Luxembourg",
    "Europe/Monaco": "Monaco",
    "Europe/Andorra": "Andorra",
    "Europe/Vatican": "Vatican",
    "Europe/San_Marino": "San Marino",
    "Europe/Malta": "Malta",
    "Europe/Gibraltar": "Gibraltar",

    // 亚洲主要时区
    "Asia/Shanghai": "Shanghai (Beijing Time)",
    "Asia/Hong_Kong": "Hong Kong",
    "Asia/Tokyo": "Tokyo",
    "Asia/Seoul": "Seoul",
    "Asia/Singapore": "Singapore",
    "Asia/Bangkok": "Bangkok",
    "Asia/Jakarta": "Jakarta",
    "Asia/Kuala_Lumpur": "Kuala Lumpur",
    "Asia/Manila": "Manila",
    "Asia/Taipei": "Taipei",
    "Asia/Macau": "Macau",
    "Asia/Ho_Chi_Minh": "Ho Chi Minh City",
    "Asia/Phnom_Penh": "Phnom Penh",
    "Asia/Vientiane": "Vientiane",
    "Asia/Yangon": "Yangon",
    "Asia/Dhaka": "Dhaka",
    "Asia/Kolkata": "Kolkata",
    "Asia/Karachi": "Karachi",
    "Asia/Kabul": "Kabul",
    "Asia/Tehran": "Tehran",
    "Asia/Dubai": "Dubai",
    "Asia/Riyadh": "Riyadh",
    "Asia/Kuwait": "Kuwait",
    "Asia/Doha": "Doha",
    "Asia/Bahrain": "Bahrain",
    "Asia/Muscat": "Muscat",
    "Asia/Baghdad": "Baghdad",
    "Asia/Damascus": "Damascus",
    "Asia/Beirut": "Beirut",
    "Asia/Jerusalem": "Jerusalem",
    "Asia/Amman": "Amman",
    "Asia/Ankara": "Ankara",
    "Asia/Tbilisi": "Tbilisi",
    "Asia/Yerevan": "Yerevan",
    "Asia/Baku": "Baku",
    "Asia/Tashkent": "Tashkent",
    "Asia/Almaty": "Almaty",
    "Asia/Bishkek": "Bishkek",
    "Asia/Dushanbe": "Dushanbe",
    "Asia/Ashgabat": "Ashgabat",
    "Asia/Samarkand": "Samarkand",
    "Asia/Urumqi": "Urumqi (Xinjiang Time)",
    "Asia/Ulaanbaatar": "Ulaanbaatar",
    "Asia/Irkutsk": "Irkutsk",
    "Asia/Vladivostok": "Vladivostok",
    "Asia/Magadan": "Magadan",
    "Asia/Sakhalin": "Sakhalin",
    "Asia/Kamchatka": "Kamchatka",
    "Asia/Anadyr": "Anadyr",

    // 非洲主要时区
    "Africa/Cairo": "Cairo",
    "Africa/Johannesburg": "Johannesburg",
    "Africa/Lagos": "Lagos",
    "Africa/Nairobi": "Nairobi",
    "Africa/Casablanca": "Casablanca",
    "Africa/Algiers": "Algiers",
    "Africa/Tunis": "Tunis",
    "Africa/Tripoli": "Tripoli",
    "Africa/Addis_Ababa": "Addis Ababa",
    "Africa/Dar_es_Salaam": "Dar es Salaam",
    "Africa/Kampala": "Kampala",
    "Africa/Khartoum": "Khartoum",
    "Africa/Kinshasa": "Kinshasa",
    "Africa/Luanda": "Luanda",
    "Africa/Maputo": "Maputo",
    "Africa/Harare": "Harare",
    "Africa/Lusaka": "Lusaka",
    "Africa/Gaborone": "Gaborone",
    "Africa/Windhoek": "Windhoek",
    "Africa/Cape_Town": "Cape Town",
    "Africa/Blantyre": "Blantyre",
    "Africa/Lilongwe": "Lilongwe",
    "Africa/Bujumbura": "Bujumbura",
    "Africa/Kigali": "Kigali",
    "Africa/Djibouti": "Djibouti",
    "Africa/Asmara": "Asmara",
    "Africa/Mogadishu": "Mogadishu",
    "Africa/Abidjan": "Abidjan",
    "Africa/Accra": "Accra",
    "Africa/Bamako": "Bamako",
    "Africa/Conakry": "Conakry",
    "Africa/Dakar": "Dakar",
    "Africa/Freetown": "Freetown",
    "Africa/Monrovia": "Monrovia",
    "Africa/Nouakchott": "Nouakchott",
    "Africa/Ouagadougou": "Ouagadougou",
    "Africa/Lome": "Lomé",
    "Africa/Porto-Novo": "Porto-Novo",
    "Africa/Cotonou": "Cotonou",
    "Africa/Niamey": "Niamey",
    "Africa/Ndjamena": "N'Djamena",
    "Africa/Bangui": "Bangui",
    "Africa/Douala": "Douala",
    "Africa/Libreville": "Libreville",
    "Africa/Malabo": "Malabo",
    "Africa/Brazzaville": "Brazzaville",

    // 大洋洲主要时区
    "Australia/Sydney": "Sydney",
    "Australia/Melbourne": "Melbourne",
    "Australia/Brisbane": "Brisbane",
    "Australia/Perth": "Perth",
    "Australia/Adelaide": "Adelaide",
    "Australia/Darwin": "Darwin",
    "Australia/Hobart": "Hobart",
    "Australia/Canberra": "Canberra",
    "Pacific/Auckland": "Auckland",
    "Pacific/Wellington": "Wellington",
    "Pacific/Suva": "Suva",
    "Pacific/Port_Moresby": "Port Moresby",
    "Pacific/Noumea": "Nouméa",
    "Pacific/Tahiti": "Tahiti",
    "Pacific/Honolulu": "Honolulu",
    "Pacific/Guam": "Guam",
    "Pacific/Saipan": "Saipan",
    "Pacific/Palau": "Palau",
    "Pacific/Yap": "Yap",
    "Pacific/Chuuk": "Chuuk",
    "Pacific/Pohnpei": "Pohnpei",
    "Pacific/Kosrae": "Kosrae",
    "Pacific/Majuro": "Majuro",
    "Pacific/Tarawa": "Tarawa",
    "Pacific/Funafuti": "Funafuti",
    "Pacific/Nauru": "Nauru",
    "Pacific/Apia": "Apia",
    "Pacific/Tongatapu": "Tongatapu",
    "Pacific/Nuku_Hiva": "Nuku Hiva",
    "Pacific/Gambier": "Gambier",
    "Pacific/Marquesas": "Marquesas",
    "Pacific/Pitcairn": "Pitcairn",
    "Pacific/Easter": "Easter Island",
    "Pacific/Galapagos": "Galápagos",

    // 大西洋时区
    "Atlantic/Reykjavik": "Reykjavik",
    "Atlantic/Azores": "Azores",
    "Atlantic/Madeira": "Madeira",
    "Atlantic/Canary": "Canary Islands",
    "Atlantic/Cape_Verde": "Cape Verde",
    "Atlantic/Bermuda": "Bermuda",
    "Atlantic/Stanley": "Stanley (Falkland Islands)",
    "Atlantic/South_Georgia": "South Georgia",

    // 印度洋时区
    "Indian/Mauritius": "Mauritius",
    "Indian/Reunion": "Réunion",
    "Indian/Mayotte": "Mayotte",
    "Indian/Comoro": "Comoro",
    "Indian/Antananarivo": "Antananarivo",
    "Indian/Maldives": "Maldives",
    "Indian/Chagos": "Chagos",
    "Indian/Christmas": "Christmas Island",
    "Indian/Cocos": "Cocos Islands",
    "Indian/Kerguelen": "Kerguelen",

    // 南极洲时区
    "Antarctica/McMurdo": "McMurdo",
    "Antarctica/South_Pole": "South Pole",
    "Antarctica/Rothera": "Rothera",
    "Antarctica/Palmer": "Palmer",
    "Antarctica/Mawson": "Mawson",
    "Antarctica/Davis": "Davis",
    "Antarctica/Casey": "Casey",
    "Antarctica/Vostok": "Vostok",
    "Antarctica/DumontDUrville": "Dumont d'Urville",
    "Antarctica/Syowa": "Syowa",
    "Antarctica/Troll": "Troll",
    "Antarctica/Macquarie": "Macquarie",
};

// 按地区分组的时区数据
export const TIMEZONE_GROUPS = {
    UTC: {
        UTC: "UTC",
    },
    "North America": {
        "America/New_York": "New York (Eastern)",
        "America/Chicago": "Chicago (Central)",
        "America/Denver": "Denver (Mountain)",
        "America/Los_Angeles": "Los Angeles (Pacific)",
        "America/Anchorage": "Anchorage (Alaska)",
        "America/Toronto": "Toronto",
        "America/Vancouver": "Vancouver",
        "America/Montreal": "Montreal",
        "America/Halifax": "Halifax",
        "America/St_Johns": "St. John's",
        "America/Mexico_City": "Mexico City",
        "America/Tijuana": "Tijuana",
        "America/Cancun": "Cancun",
    },
    "South America": {
        "America/Sao_Paulo": "São Paulo",
        "America/Buenos_Aires": "Buenos Aires",
        "America/Santiago": "Santiago",
        "America/Lima": "Lima",
        "America/Bogota": "Bogotá",
        "America/Caracas": "Caracas",
        "America/La_Paz": "La Paz",
        "America/Montevideo": "Montevideo",
        "America/Asuncion": "Asunción",
        "America/Guayaquil": "Guayaquil",
    },
    Europe: {
        "Europe/London": "London",
        "Europe/Paris": "Paris",
        "Europe/Berlin": "Berlin",
        "Europe/Rome": "Rome",
        "Europe/Madrid": "Madrid",
        "Europe/Amsterdam": "Amsterdam",
        "Europe/Brussels": "Brussels",
        "Europe/Zurich": "Zurich",
        "Europe/Vienna": "Vienna",
        "Europe/Prague": "Prague",
        "Europe/Budapest": "Budapest",
        "Europe/Warsaw": "Warsaw",
        "Europe/Stockholm": "Stockholm",
        "Europe/Copenhagen": "Copenhagen",
        "Europe/Oslo": "Oslo",
        "Europe/Helsinki": "Helsinki",
        "Europe/Athens": "Athens",
        "Europe/Istanbul": "Istanbul",
        "Europe/Moscow": "Moscow",
        "Europe/Kiev": "Kiev",
        "Europe/Bucharest": "Bucharest",
        "Europe/Sofia": "Sofia",
        "Europe/Belgrade": "Belgrade",
        "Europe/Zagreb": "Zagreb",
        "Europe/Ljubljana": "Ljubljana",
        "Europe/Sarajevo": "Sarajevo",
        "Europe/Dublin": "Dublin",
        "Europe/Lisbon": "Lisbon",
        "Europe/Reykjavik": "Reykjavik",
    },
    Asia: {
        "Asia/Shanghai": "Shanghai (Beijing Time)",
        "Asia/Hong_Kong": "Hong Kong",
        "Asia/Tokyo": "Tokyo",
        "Asia/Seoul": "Seoul",
        "Asia/Singapore": "Singapore",
        "Asia/Bangkok": "Bangkok",
        "Asia/Jakarta": "Jakarta",
        "Asia/Kuala_Lumpur": "Kuala Lumpur",
        "Asia/Manila": "Manila",
        "Asia/Taipei": "Taipei",
        "Asia/Macau": "Macau",
        "Asia/Ho_Chi_Minh": "Ho Chi Minh City",
        "Asia/Dhaka": "Dhaka",
        "Asia/Kolkata": "Kolkata",
        "Asia/Karachi": "Karachi",
        "Asia/Kabul": "Kabul",
        "Asia/Tehran": "Tehran",
        "Asia/Dubai": "Dubai",
        "Asia/Riyadh": "Riyadh",
        "Asia/Kuwait": "Kuwait",
        "Asia/Doha": "Doha",
        "Asia/Bahrain": "Bahrain",
        "Asia/Muscat": "Muscat",
        "Asia/Baghdad": "Baghdad",
        "Asia/Damascus": "Damascus",
        "Asia/Beirut": "Beirut",
        "Asia/Jerusalem": "Jerusalem",
        "Asia/Amman": "Amman",
        "Asia/Ankara": "Ankara",
        "Asia/Tbilisi": "Tbilisi",
        "Asia/Yerevan": "Yerevan",
        "Asia/Baku": "Baku",
        "Asia/Tashkent": "Tashkent",
        "Asia/Almaty": "Almaty",
        "Asia/Urumqi": "Urumqi (Xinjiang Time)",
        "Asia/Ulaanbaatar": "Ulaanbaatar",
    },
    Africa: {
        "Africa/Cairo": "Cairo",
        "Africa/Johannesburg": "Johannesburg",
        "Africa/Lagos": "Lagos",
        "Africa/Nairobi": "Nairobi",
        "Africa/Casablanca": "Casablanca",
        "Africa/Algiers": "Algiers",
        "Africa/Tunis": "Tunis",
        "Africa/Tripoli": "Tripoli",
        "Africa/Addis_Ababa": "Addis Ababa",
        "Africa/Dar_es_Salaam": "Dar es Salaam",
        "Africa/Kampala": "Kampala",
        "Africa/Khartoum": "Khartoum",
        "Africa/Kinshasa": "Kinshasa",
        "Africa/Luanda": "Luanda",
        "Africa/Maputo": "Maputo",
        "Africa/Harare": "Harare",
        "Africa/Lusaka": "Lusaka",
        "Africa/Gaborone": "Gaborone",
        "Africa/Windhoek": "Windhoek",
        "Africa/Cape_Town": "Cape Town",
        "Africa/Abidjan": "Abidjan",
        "Africa/Accra": "Accra",
        "Africa/Dakar": "Dakar",
        "Africa/Monrovia": "Monrovia",
    },
    Oceania: {
        "Australia/Sydney": "Sydney",
        "Australia/Melbourne": "Melbourne",
        "Australia/Brisbane": "Brisbane",
        "Australia/Perth": "Perth",
        "Australia/Adelaide": "Adelaide",
        "Australia/Darwin": "Darwin",
        "Australia/Hobart": "Hobart",
        "Australia/Canberra": "Canberra",
        "Pacific/Auckland": "Auckland",
        "Pacific/Wellington": "Wellington",
        "Pacific/Suva": "Suva",
        "Pacific/Port_Moresby": "Port Moresby",
        "Pacific/Noumea": "Nouméa",
        "Pacific/Tahiti": "Tahiti",
        "Pacific/Honolulu": "Honolulu",
        "Pacific/Guam": "Guam",
    },
};

// 导出默认时区数据（与 react-timezone-select 兼容）
export default AVIATION_TIMEZONES;
